// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        suggestionMobileStyle: 'style1'
    }
};

// Override Settings
(function () {  // Add this
  BoostPFS.inject(this);  // Add this

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
  };
  InstantSearchMobile.prototype.afterBindEvents = function() {
    var self = this;

    jQ('.header__action-item-link[data-action="toggle-search"]').off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ('.search-bar__input').focus();
      self.openSuggestionMobile();
    });

  }
  InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function(isClose) {
    //Fix conflict with theme search
    jQ('.header__search-bar-wrapper').removeClass('is-visible');
    jQ('header.header.header--inline').removeClass('header--search-expanded');
  }

  InstantSearchResultItemProduct.prototype.compileTemplate = function() {
    if (this.isShow) {
      var searchTerm = Utils.stripHtml(Globals.currentTerm);
      // Product image
      var imageHTML = '';
      if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
        imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
        imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
      }
      // Product title
      var productTitle = this.customizeProductTitle();
      productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
      // SKU
      var skuHTML = '';
      if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
        skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
        skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
      }
      // Vendor
      var vendorHTML = '';
      if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
        vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
        vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
      }
      // Price
      var priceHTML = this.data.tags.includes('請查詢') ? '請查詢 / Ask' : this.compileSuggestionProductPrice();
      // Open the result item in new tab when selected
      var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
      return this.getTemplate().replace(/{{id}}/g, this.id).replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type)).replace(/{{url}}/g, this.url).replace(/{{newTabAttribute}}/g, newTabAttr).replace(/{{itemProductImage}}/g, imageHTML).replace(/{{title}}/g, productTitle).replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle)).replace(/{{itemProductSku}}/g, skuHTML).replace(/{{itemProductVendor}}/g, vendorHTML).replace(/{{itemProductPrice}}/, priceHTML).replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion).replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem).replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
    } else {
      return '';
    }
  }
})();  // Add this at the end